import { pluralize } from '@srm/ui/lib/pluralize';

interface IPickerFooter {
    ready: boolean;
    isMultiple: boolean;
    /** Пунктов в списке сейчас. */
    count: number;
    selected: number;
    /** Строк в ответе и сколько всего подходит. */
    shown: number;
    total: number;
    query: string;
    /** Формы слова для счётчика: «значение, значения, значений». */
    forms: [string, string, string];
}

/** Подпись подвала выпадающего списка: выбрано, найдено, «показаны первые N из M» или сколько всего. */
export function pickerFooterText({ ready, isMultiple, count, selected, shown, total, query, forms }: IPickerFooter) {
    // пустой список объясняет себя сам — «0 записей» под ним лишнее
    if (!ready || (!isMultiple && !count)) return '';
    if (isMultiple) return `Выбрано: ${selected}`;
    if (total > shown) return `Показаны первые ${shown} из ${total} — уточните поиск`;
    if (query) return `Найдено: ${total}`;
    return `${total} ${pluralize(total, forms)}`;
}
